export function getHoursFromOpenCloseValues(
  open_at?: string,
  closed_at?: string
): number {
  if (!open_at || !closed_at) {
    return 0;
  }

  const openTime = parseInt(open_at, 10);
  const closeTime = parseInt(closed_at, 10);

  if (isNaN(openTime) || isNaN(closeTime)) {
    return 0;
  }

  const openHours = Math.floor(openTime / 100);
  const closeHours = Math.floor(closeTime / 100);
  const openMinutes = openTime % 100;
  const closeMinutes = closeTime % 100;

  const totalOpenMinutes = openHours * 60 + openMinutes;
  const totalCloseMinutes = closeHours * 60 + closeMinutes;

  const totalHours = (totalCloseMinutes - totalOpenMinutes) / 60;

  return totalHours > 0 ? totalHours : 0;
}
